export var Angles;
(function (_Angles) {
  function angle(a, b, center) {
    var v1 = {
      x: b.x - center.x,
      y: b.y - center.y
    };
    var v2 = {
      x: a.x - center.x,
      y: a.y - center.y
    };
    var dot = v1.x * v2.x + v1.y * v2.y;
    var det = v1.x * v2.y - v1.y * v2.x;
    return Math.round(Math.atan2(det, dot) / Math.PI * 180);
  }
  _Angles.angle = angle;
})(Angles || (Angles = {}));